import { render, staticRenderFns } from "./AllocationFreeEntry.vue?vue&type=template&id=401636b5&"
import script from "./AllocationFreeEntry.vue?vue&type=script&lang=js&"
export * from "./AllocationFreeEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports